import React from "react";
import { Box, Text, Link, useColorMode } from "@chakra-ui/react";
import { getColor } from "../../../brandConfig";

export const PoweredBy: React.FC = () => {
  const { colorMode } = useColorMode();
  const textSecondary = getColor(colorMode === 'light' ? "text.secondary" : "text.secondaryDark", colorMode);

  return (
    <Box mt={8} mb={4}>
      <Text fontSize="sm" color={textSecondary}>
        Powered by <Link href="https://www.tommillerservices.com/businessbuilder" isExternal color={textSecondary} textDecoration="underline">Business Builder</Link> system brought to you by <Link href="https://www.tommillerservices.com/" isExternal color={textSecondary} textDecoration="underline">Tom Miller Services</Link>.
      </Text>
    </Box>
  );
};

export default PoweredBy;
